"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
lodash_1.default.mixin({
    mergeByKey: (arr1, arr2, key) => {
        const criteria = {};
        criteria[key] = null;
        return lodash_1.default.map(arr1, (item) => {
            criteria[key] = item[key];
            return lodash_1.default.merge(item, lodash_1.default.find(arr2, criteria));
        });
    },
});
